module.exports = __webpack_public_path__ + "img/drawer-pack.9a65eb37.svg";